import type { RouterConfig } from '@nuxt/schema'
import { getAnimationBehaviour } from '~/utils/entity-checks'

export default <RouterConfig>{
  scrollBehavior(to, _from, savedPosition) {
    const scrollBehaviour = getAnimationBehaviour()

    if (savedPosition) {
      return savedPosition
    } else if (to.hash) {
      return {
        el: to.hash,
        behavior: scrollBehaviour
      }
    } else {
      return { top: 0, behavior: scrollBehaviour }
    }
  }
}
